import { useGetLessonPlansForOrganisationQuery } from '@/app/redux/endpoints/lessonPlans';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';
import { LessonPlan } from '@/common/types/lessonPlan';
import { useMemo } from 'react';

export function useLessonPlans() {
  const { currentOrganisationId } = useCurrentOrganisationId();
  const skip = !currentOrganisationId;

  const { data: lessonPlans = [], isLoading, isFetching, error } =
    useGetLessonPlansForOrganisationQuery(currentOrganisationId!, { skip });

  const lessonPlansById = useMemo(() => {
    const byId = new Map<string, LessonPlan>();
    for (const lp of lessonPlans) byId.set(lp.id, lp);
    return byId;
  }, [lessonPlans]);

  return { lessonPlans, lessonPlansById, isLoading, isFetching, error };
}
